import { ClientNode } from '../../../model/client-model/client-node';
import { ClientBoardContainer } from '../../../public/dashboard/shared/model/client-board-container';
import { DashboardNodeV3 } from '../../../public/dashboard/v3/dashboard-node-v3';
import { DashboardV3 } from '../../../public/dashboard/v3/dashboard-v3';

export function getNodes(board: DashboardV3): DashboardNodeV3[];
export function getNodes(board: ClientBoardContainer): ClientNode[];
export function getNodes(board: ClientBoardContainer | DashboardV3): ClientNode[] | DashboardV3[] {
  return Object.values(board.nodes);
}
